import { Theme } from '../styles/styles';
import { ColorsPaletteLight, highChartLegendItemBoxShadow, highChartLegendItemBoxShadowDark } from '../theme/constants';

export interface HighChartTooltipStyleProps {
  isDarkTheme?: boolean;
}

export const getHighChartTooltipStyles = (theme: Theme, isMobile: boolean) => ({
  '& .highcharts-label.highcharts-tooltip-box, & .highcharts-label.highcharts-tooltip': {
    borderRadius: '16px !important',
    border: `1px solid ${theme.color.greys[15]} !important`,
    backgroundColor: `${ColorsPaletteLight.greys[0]} !important`,
    boxShadow: ({ isDarkTheme }: HighChartTooltipStyleProps) =>
      isDarkTheme ? `${highChartLegendItemBoxShadowDark} !important` : `${highChartLegendItemBoxShadow} !important`,
    padding: '8px !important',
    boxSizing: 'border-box',
    width: isMobile ? undefined : 'max-content !important',
    maxWidth: isMobile ? '95vw !important' : 'none !important',
  },

  '& .highcharts-label.highcharts-tooltip-box > span, & .highcharts-label.highcharts-tooltip > span': {
    position: 'relative !important',
    left: '0 !important',
    top: '0 !important',
    marginLeft: '0 !important',
    marginTop: '0 !important',
    whiteSpace: isMobile ? 'normal !important' : 'nowrap !important',
    width: isMobile ? undefined : 'max-content !important',
  },
});

export const getHighChartA11yProxyContainerStyles = () => ({
  '& .highcharts-a11y-proxy-container-before, & .highcharts-a11y-proxy-container-after': {
    width: '0 !important',
    height: '0 !important',
    overflow: 'visible !important',
    padding: '0 !important',
    margin: '0 !important',
  },
});

export const getHighChartChartWrapperStyles = (theme: Theme, isMobile: boolean) => ({
  ...getHighChartTooltipStyles(theme, isMobile),
  ...getHighChartA11yProxyContainerStyles(),
});

export const getChartTimeRangesPanelStyles = (theme: Theme) => ({
  display: 'flex',
  alignItems: 'flex-end',
  gap: 20,
  marginBottom: 24,
  marginTop: 24,
  [theme.breakpoints.down('sm')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 24,
    marginBottom: 0,
  },
});

// !important is required to override Highcharts inline styles
export const getHighChartLegendInteractionStyles = (theme: Theme) => ({
  '& .highcharts-a11y-proxy-group .highcharts-a11y-proxy-element': {
    pointerEvents: 'none',
  },
  '& .highcharts-legend-item-hidden': {
    '& .fund-legend-item': {
      border: ({ isDarkTheme }: HighChartTooltipStyleProps) =>
        isDarkTheme ? `1px solid ${theme.color.functional.disabled} !important` : `1px solid ${theme.color.greys[40]} !important`,
      color: `${theme.color.functional.disabled} !important`,
    },
    '& .fund-legend-dot': {
      backgroundColor: ({ isDarkTheme }: HighChartTooltipStyleProps) =>
        isDarkTheme ? `${theme.color.functional.disabled} !important` : `${theme.color.greys[40]} !important`,
    },
  },
  '& .highcharts-legend-item:hover .fund-legend-item, & .highcharts-legend-item-hidden:hover .fund-legend-item': {
    border: ({ isDarkTheme }: HighChartTooltipStyleProps) =>
      isDarkTheme ? `1px solid ${theme.color.greys[80]} !important` : `1px solid ${theme.color.greys[70]} !important`,
    boxShadow: ({ isDarkTheme }: HighChartTooltipStyleProps) =>
      isDarkTheme ? `${highChartLegendItemBoxShadowDark} !important` : `${highChartLegendItemBoxShadow} !important`,
  },
});

